const data = [
    {
        id: 1,
        first_name: "Grove",
        last_name: "Rioch",
        email: "grioch0@imageshack.us",
        gender: "Male",
        ip_address: "207.250.246.235",
        expandableData:
        {
            current_address: "PO Box 22447",
            permanent_address: "3 Thackeray Terrace",

        }
    },
    {
        id: 2,
        first_name: "Hobie",
        last_name: "Daniele",
        email: "hdaniele1@sciencedirect.com",
        gender: "Male",
        ip_address: "198.196.149.210",
        expandableData: {
            current_address: "PO Box 22447",
            permanent_address: "3 Thackeray Terrace",

        }
    },
    {
        id: 3,
        first_name: "Ripley",
        last_name: "Pauletto",
        email: "rpauletto2@friendfeed.com",
        gender: "Male",
        ip_address: "108.85.230.91",
        expandableData: {
            current_address: "PO Box 22447",
            permanent_address: "3 Thackeray Terrace",

        }
    },
    {
        id: 4,
        first_name: "Gerrie",
        last_name: "Di Bernardo",
        email: "gdibernardo3@last.fm",
        gender: "Male",
        ip_address: "111.224.77.2",
        expandableData: {
            current_address: "PO Box 22447",
            permanent_address: "3 Thackeray Terrace",

        }
    },
    {
        id: 5,
        first_name: "Artus",
        last_name: "Veneur",
        email: "aveneur4@freewebs.com",
        gender: "Male",
        ip_address: "216.227.14.93",
        expandableData: {
            current_address: "PO Box 22447",
            permanent_address: "3 Thackeray Terrace",

        }
    },
    {
        id: 6,
        first_name: "Valida",
        last_name: "Drewson",
        email: "vdrewson5@drupal.org",
        gender: "Female",
        ip_address: "30.31.4.230",
        expandableData: {
            current_address: "PO Box 22447",
            permanent_address: "3 Thackeray Terrace",

        }
    },
    {
        id: 7,
        first_name: "Cornelle",
        last_name: "Pringley",
        email: "cpringley6@unesco.org",
        gender: "Genderfluid",
        ip_address: "83.97.38.164",
        expandableData: {
            current_address: "PO Box 22447",
            permanent_address: "3 Thackeray Terrace",

        }
    },
]

export default data;